
<ng-container *ngIf="isLoggedIn$ | async">
    <ng-container *ngIf="isAgent$ | async">
        <terra-main-nav />
    </ng-container>

    <ng-container *ngIf="isLp$ | async">
        <terra-lp-desktop-nav />
    </ng-container>
</ng-container>

<div class="container support-header" fxLayoutAlign="space-between center">
    <div>
        <h1>Contact us</h1>
    </div>
</div>
<div class="support-content container">
    <div id="hubspotForm"> </div>
</div>

<ng-container *ngIf="isLp$ | async">
    <terra-lp-mobile-nav />
</ng-container>